import { render, staticRenderFns } from "./indica-form.vue?vue&type=template&id=19ff91e6&"
import script from "./indica-form.vue?vue&type=script&lang=js&"
export * from "./indica-form.vue?vue&type=script&lang=js&"
import style0 from "./indica-form.vue?vue&type=style&index=0&id=19ff91e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports